import React, { useEffect } from 'react';
import noop from 'lodash/noop';

import DashboardTabs from '../DashboardTabs';
import styles from './index.less';

const DashboardNavigator = ({
  list,
  tabs,
  listLoader,
  getList,
  extraComponent,
  isSharing,
}) => {
  useEffect(() => {
    getList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderTabs = () => (
    <DashboardTabs
      isFetching={listLoader}
      list={list}
      tabs={tabs}
      extraComponent={extraComponent}
    />
  );

  return (
    <div className={styles.dashboardNavigator}>
      { // sharing page hidden tabs
        !isSharing && renderTabs()
      }
    </div>
  );
};

DashboardNavigator.defaultProps = {
  tabs: [],
  list: [],
  getList: noop,
  extraComponent: null,
  isSharing: false,
};

export default DashboardNavigator;
